import { mainSiteUrl } from '@/mocks/homeData';

export default function PanoramicCTA() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20abstract%20composition%20of%20soft%20sand%20and%20terracotta%20tones%20with%20subtle%20fashion%20accessory%20silhouettes%20organic%20flowing%20lines%20gentle%20gradient%20transitions%20from%20light%20to%20warm%20medium%20tones%20editorial%20background%20with%20ample%20copy%20space%20modern%20minimalist%20aesthetic%20suitable%20for%20text%20overlay&width=1920&height=700&seq=cta-panoramic-v2-5q9s&orientation=landscape"
          alt="SpreadsheetHub product panorama"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="relative min-h-[320px] md:min-h-[380px]">
          <div className="absolute top-0 left-0 max-w-xl">
            <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-none lowercase">
              discover, compare<br />and research faster
            </h2>
          </div>

          <div className="absolute bottom-0 left-0">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-7 py-3.5 rounded-full bg-white text-foreground-900 text-sm font-semibold hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <span>Explore Main Website</span>
              <div className="w-6 h-6 rounded-full bg-foreground-900 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-xs"></i>
              </div>
            </a>
          </div>

          <div className="absolute bottom-0 right-0 max-w-sm text-right">
            <p className="text-sm md:text-base text-white/60 font-light leading-relaxed">
              Independent research platform.<br />Not officially affiliated with any shopping agent.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}